<template>
	<div style="padding-top:.5rem; text-align:center" >
		没有搜索到更多数据!!!
	</div>
</template>
<script>
export default{
	name:'no-data-dialog',
	data(){
		return {}
	}
}
</script>


// WEBPACK FOOTER //
// noDataDialog.vue?80f10f1a